import { render, staticRenderFns } from "./SkeletonContent.vue?vue&type=template&id=74bde124&scoped=true"
import script from "./SkeletonContent.vue?vue&type=script&lang=js"
export * from "./SkeletonContent.vue?vue&type=script&lang=js"
import style0 from "./SkeletonContent.vue?vue&type=style&index=0&id=74bde124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bde124",
  null
  
)

export default component.exports